import store from '../store/store.js'//引入store
import { Toast } from 'mint-ui';
import oRequest from '../libsV2/request.js';

const URL = {
    MEBER_INFO               : 'member/process/info',//交付详情
    MEBER_LISTS              : 'member/process/lists',//交付列表
    GET_INFO                 : 'user/index/index',//用户信息
    MEBER_TAG                : 'member/process/tag',//评价tag
    MEBER_APPRAISE           : 'member/process/appraise',//提交报告评价
    // 交付报告2.0
    MEBER_LISTS_V2           : 'member/process/listsv2',//交付报告列表2.0
    TAG_LIST_V2              : 'discuss.indexv2/tag_list',//系统施工评价标签
    EVA_INFO                 : 'discuss.indexv2/completed_list',//评价详情
    ADD_EVA                  : 'discuss.indexv2/discuss_add',//提交评价
    MEMBER_PROCESS_INFOV2    : 'member/process/infov2',//交付详情2.0
}

export default {
    processInfoV2(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.MEMBER_PROCESS_INFOV2, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    addEva(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.ADD_EVA, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    evaInfo(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.EVA_INFO, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    tagList(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.TAG_LIST_V2, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    memberlistV2(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.MEBER_LISTS_V2, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getMemberAppraise(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.MEBER_APPRAISE, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getMemberTag(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.MEBER_TAG, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getUserInfo(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.GET_INFO, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getMeberLists(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.MEBER_LISTS, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
    getMeberInfo(data = {}) {
        const resquestData = Object.assign({}, data);
        return new Promise((resolve, recject) => {
            oRequest.getData(URL.MEBER_INFO, resquestData).then(res => {
                if (res.data.error == 0) {
                    resolve(res.data.data);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 1200
                    });
                    store.commit('loadSwitch', false);
                    throw 0;
                }
            })
        })
    },
}
